import { contextFactory } from '@10d/tend-ui-factories';

const [SizeContext, useSizeContext] = contextFactory();

export { SizeContext, useSizeContext };
